<template>
  <div v-if="stock_take_order">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('Shops', 'shopStockTakeOrdersDetails')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/shop-stock-take-orders/' + stock_take_order.id + '?shop_id=' + shop_id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("shopStockTakeOrders.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 导出 -->
      <v-tooltip v-if="showExport && $permission.permissionAllow('Shops', 'shopStockTakeOrdersDetailsExport')" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click="stockTakeOrdersExport()"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("shopStockTakeOrders.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("shopStockTakeOrders.actions.export") }}</span>
      </v-tooltip>
<!--      &lt;!&ndash; 盘点 &ndash;&gt;-->
<!--      <v-tooltip top v-if="showStockTake && $permission.permissionAllow('StockTakes', 'stockTake')">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-btn-->
<!--            v-bind="attrs"-->
<!--            v-on="on"-->
<!--            small-->
<!--            dark-->
<!--            color="info"-->
<!--            class="px-2 me-2 mb-1"-->
<!--            @click.stop="checkActions()"-->
<!--          >-->
<!--            {{ $t("shopStockTakeOrders.actions.stockTake") }}-->
<!--          </v-btn>-->
<!--        </template>-->
<!--        <span>{{ $t("shopStockTakeOrders.actions.stockTake") }}</span>-->
<!--      </v-tooltip>-->
<!--      &lt;!&ndash; 作废 &ndash;&gt;-->
<!--      <v-tooltip top v-if="showCancel && $permission.permissionAllow('StockTakes', 'cancel')">-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-btn-->
<!--            v-bind="attrs"-->
<!--            v-on="on"-->
<!--            small-->
<!--            dark-->
<!--            color="danger"-->
<!--            class="px-2 me-2 mb-1"-->
<!--            @click.stop="cancelAlert = true"-->
<!--          >-->
<!--            <v-icon x-small class="pe-1">fa-exclamation</v-icon>-->
<!--            {{ $t("shopStockTakeOrders.actions.cancel") }}-->
<!--          </v-btn>-->
<!--        </template>-->
<!--        <span>{{ $t("shopStockTakeOrders.actions.cancelStockStakeOrder") }}</span>-->
<!--      </v-tooltip>-->
    </v-sheet>
  </div>
</template>

<script>
import Shops from "@/api/shops";
import {mapState} from "vuex";
// import i18n from "@/i18n";
export default {
  name: "StockTakeOrderActions",

  components: {

  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo"]),
  },

  props: {
    stock_take_order: Object,
    shop_id: [Number, String],
    detailMode: Boolean,
    showView: Boolean,
    showExport: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    doPrint() {
      // this.$permission.checkAccountExpired().then(
      //   function () {
      //     //console.log(mode);
      //     // TODO print
      //   }.bind(this)
      // );
    },
    stockTakeOrdersExport() {
      Shops.shopStockTakeOrdersDetailsExport({
        shop_id: this.shop_id,
        stock_take_id: this.stock_take_order.id,
        account_id: this.accountInfo.account_id
      });
    },
    checkActions() {
      // Shops.checkAction(3).then(
      //   function (response) {
      //     if (response.data.status.isOK()) {
      //       if (response.data.data.actions) {
      //         this.detailMode
      //           ? this.$emit("stockTake")
      //           : this.$router.push(
      //               "/stock-takes/" + this.stock_take_order.id + "/stockTake"
      //             );
      //       } else {
      //         this.$snackbar.error(i18n.t(response.data.data.msg));
      //       }
      //     }
      //   }.bind(this)
      // );
    },
  },
};
</script>